import { getCurrentUser } from "../../common/utils";
import PrestadorPage from "./PrestadorPage";
import NavegadoraPage from "./NavegadoraPage";
import { Spinner } from "react-bootstrap";

const ReportesFarmacoRouter = () => {
  const dados_usuario = getCurrentUser();

  // Administrador/superuser tem tipo_usuario vazio, então só aguardamos quando
  // os dados do usuário ainda não foram carregados.
  if (!dados_usuario) {
    return (
      <div className="text-center p-5">
        <Spinner animation="border" />
      </div>
    );
  }

  if (dados_usuario.tipo_usuario === "prestador") {
    return <PrestadorPage />;
  } else {
    return <NavegadoraPage />;
  }
};

export default ReportesFarmacoRouter;
